/**
 * Categories for wireframe components
 */
export enum ComponentCategory {
  Form = 0,        // Button, Input, Select, Checkbox, etc.
  Layout = 1,      // Card, Panel, Divider, Container, etc.
  Navigation = 2,  // Menu, Tabs, Breadcrumb, Pagination, etc.
  Data = 3,        // Table, List, Tree, Tag, Badge, etc.
  Feedback = 4,    // Alert, Dialog, Tooltip, Progress, etc.
  Media = 5,       // Image, Icon, Avatar, etc.
  Typography = 6,  // Heading, Text, Link, Label, etc.
  Shape = 7        // Rectangle, Circle, Line, Triangle, etc.
}

export const ComponentCategoryLabels: Record<ComponentCategory, string> = {
  [ComponentCategory.Form]: 'Formulaires',
  [ComponentCategory.Layout]: 'Mise en page',
  [ComponentCategory.Navigation]: 'Navigation',
  [ComponentCategory.Data]: 'Donnees',
  [ComponentCategory.Feedback]: 'Feedback',
  [ComponentCategory.Media]: 'Medias',
  [ComponentCategory.Typography]: 'Typographie',
  [ComponentCategory.Shape]: 'Formes'
}

export const ComponentCategoryIcons: Record<ComponentCategory, string> = {
  [ComponentCategory.Form]: 'Edit',
  [ComponentCategory.Layout]: 'Grid',
  [ComponentCategory.Navigation]: 'Menu',
  [ComponentCategory.Data]: 'List',
  [ComponentCategory.Feedback]: 'Warning',
  [ComponentCategory.Media]: 'Picture',
  [ComponentCategory.Typography]: 'Document',
  [ComponentCategory.Shape]: 'FullScreen'
}
